import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const StyledItem = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.lightGray.main}`,
  borderRadius: 8,
  padding: '1rem 1.25rem',
  display: 'flex',
  justifyContent: 'space-between',
}))

export const StyledMatchCard = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: '16px 20px',
  borderRadius: '0.5rem',
  border: `1px solid ${theme.palette.lightGray.main}`,
}))

export const StyledTag = styled(Box, {
  shouldForwardProp: prop => prop !== 'score',
})<{ score?: boolean }>(({ theme, score }) => ({
  border: score
    ? `1px solid ${theme.palette.lightGreen.main}`
    : `1px solid ${theme.palette.mediumGreen.main}`,
  borderRadius: '30px',
  padding: '4px 20px',
  backgroundColor: score ? theme.palette.lightGreen.main : 'transparent',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const StyledSaveIcon = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  position: 'absolute',
  top: '20px',
  right: '20px',
}))
